import React from 'react';

interface TestimonialCardProps {
  text: string;
  author: string;
  role: string;
}

const TestimonialCard = ({ text, author, role }: TestimonialCardProps) => {
  return (
    <div className="glass-card p-8 flex flex-col gap-6">
      <div className="flex gap-1">
        {[...Array(5)].map((_, i) => (
          <svg key={i} className="w-4 h-4 text-gold-500 fill-gold-500" viewBox="0 0 20 20">
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
          </svg>
        ))}
      </div>
      <p className="text-slate-600 leading-relaxed italic flex-1">"{text}"</p>
      <div className="border-t border-slate-100 pt-4 flex items-center gap-3">
        <div className="w-9 h-9 rounded-full bg-brand-100 flex items-center justify-center text-brand-700 font-bold text-sm font-display">
          {author.charAt(0)}
        </div>
        <div>
          <p className="font-semibold text-slate-900 text-sm">{author}</p>
          <p className="text-brand-500 text-xs font-medium">{role}</p>
        </div>
      </div>
    </div>
  );
};

export default TestimonialCard;
